import HeroSection from './components/HeroSection';
import FeatureSection from './components/FeatureSection';
import CategorySection from './components/CategorySection';
import CreatorSection from './components/CreatorSection';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';
import SEOHead from '@/components/feature/SEOHead';

const homepageSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '快猫平台',
  url: 'https://kuaimao.com',
  description: '快猫是备受用户青睐的内容创作与短视频平台，汇聚海量优质创作者与精彩内容。',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'https://kuaimao.com/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
};

const orgSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: '快猫平台',
  url: 'https://kuaimao.com',
  description: '快猫是备受用户青睐的内容创作与短视频平台。',
  contactPoint: {
    '@type': 'ContactPoint',
    telephone: '400-888-6666',
    contactType: 'customer service',
    availableLanguage: 'Chinese',
  },
};

const faqPageSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    {
      '@type': 'Question',
      name: '快猫平台是免费使用的吗？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '是的，快猫平台的基础功能对所有用户完全免费。你可以免费注册账号、发布视频、浏览内容和与其他用户互动。',
      },
    },
    {
      '@type': 'Question',
      name: '如何在快猫上开始创作第一条视频？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '下载快猫应用并注册账号后，点击底部"+"按钮即可进入创作界面。快猫内置了丰富的编辑工具，包括剪辑、配乐、滤镜、字幕和特效等。',
      },
    },
    {
      '@type': 'Question',
      name: '快猫创作者激励计划需要满足什么条件？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '基础参与条件包括：账号注册满30天、累计发布原创视频不少于20条、账号信用分在90分以上。满足条件后可在"创作者中心"申请加入。',
      },
    },
  ],
};

export default function Home() {
  return (
    <>
      <SEOHead
        title="快猫——官方落地页，快猫平台核心功能全解析 | 快猫官方入口"
        description="快猫是备受用户青睐的内容创作与短视频平台，汇聚海量优质创作者与精彩内容。本页详细介绍快猫的核心功能、使用指南、创作者激励计划及安全保障机制。"
        keywords="快猫,快猫平台下载,快猫创作者入驻,快猫短视频,快猫官方入口,快猫变现攻略,快猫使用教程"
        schemaJson={{ ...homepageSchema, ...orgSchema, ...faqPageSchema }}
      />
      <main>
        <HeroSection />
        <FeatureSection />
        <CategorySection />
        <CreatorSection />
        <FAQSection />
        <CTASection />
      </main>
    </>
  );
}